import pushGTMEvent from '@helpers/analyticsHelpers/pushGTMEvent';

export const trackBankIdModalShown = (isB2BCustomer: boolean) => {
  pushGTMEvent({
    event: 'Track',
    category: 'checkout',
    action: `${isB2BCustomer ? 'corporate_customers_' : ''}identify_BankID_modal_shown`,
    label: '',
    value: 0,
  });
};

export const trackBankIdSignIn = (isB2BCustomer: boolean, isMobile: boolean) => {
  pushGTMEvent({
    event: 'Track',
    category: 'checkout',
    action: `${isB2BCustomer ? 'corporate_customers_' : ''}identify_with_${isMobile ? 'mobile_' : ''}BankId`,
    label: '',
    value: 0,
  });
};
